import { atom } from 'jotai'

export const initLogAtom = atom<string[]>([])
export const migrationProcessAtom = atom<string>('')
